<template>
<div :class="[{root: true, sidebarClose, sidebarStatic}, 'sing-dashboard']">
  <Sidebar />
 <!-- <Helper />-->
  <div class="wrap">
    <Header />
    <v-touch class="content" @swipe="handleSwipe" :swipe-options="{direction: 'horizontal'}">
      <breadcrumb-history></breadcrumb-history>
      <transition name="router-animation">
        <router-view />
      </transition>
      <footer class="contentFooter">
        Ekhoni Daktar - Made by <a href="https://innovabd.tech" rel="nofollow noopener noreferrer" target="_blank">Innova Tech</a>
      </footer>
    </v-touch>
  </div>
</div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions } = createNamespacedHelpers('adminLayout');

import Sidebar from '@/components/admin/Sidebar/Sidebar';
import Header from '@/components/admin/Header/Header';
import BreadcrumbHistory from '@/components/admin/BreadcrumbHistory/BreadcrumbHistory';

import './AdminLayout.scss';
import DoctorService from "@/services/general_user/doctor.service";

export default {
  name: 'AdminLayout',
  components: { Sidebar, Header, BreadcrumbHistory },
  methods: {
    ...mapActions(['setdoctortype', 'switchSidebar', 'handleSwipe', 'changeSidebarActive', 'toggleSidebar']),
    handleWindowResize() {
      const width = window.innerWidth;

      if (width <= 768 && this.sidebarStatic) {
        this.toggleSidebar();
        this.changeSidebarActive(null);
      }
    },
    fetchDoctorTypes() {
      DoctorService.fetchDoctorTypes()
          .then((response) => {
            if (response.status === 200) {
              this.setdoctortype(response.data);
            }
          })
    },
  },
  computed: {
    ...mapState(["sidebarClose", "sidebarStatic"]),
  },

  created() {
    const staticSidebar = JSON.parse(localStorage.getItem('sidebarStatic'));

    if (staticSidebar) {
      this.$store.state.layout.sidebarStatic = true;
    } else if (!this.sidebarClose) {
      setTimeout(() => {
        this.switchSidebar(true);
        this.changeSidebarActive(null);
      }, 2500);
    }

    this.handleWindowResize();
    window.addEventListener('resize', this.handleWindowResize);
  },
  mounted() {
    this.fetchDoctorTypes();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  }
};
</script>

<style src="./AdminLayout.scss" lang="scss" />
